import { defineStore } from 'pinia'

export default defineStore({
  id: 'Home',
  state: () => {
    const bookCursorsString = window.localStorage.getItem('bookCursors')
    let bookCursors = {}

    if (bookCursorsString) {
      bookCursors = JSON.parse(bookCursorsString)
    }

    return {
      bookCursors,
    }
  },
  getters: {
    BookCursors: state => state.bookCursors,
  },
  actions: {
    updateBookCursors(Books = []) {
      const bookCursors: Record<string, any[]> = {}

      Books.forEach((book: any) => {
        const id = book.id

        if (!bookCursors[id]) {
          bookCursors[id] = []
        }

        // 查找是否有重复id
        const bookCursor = bookCursors[id]
        const index = bookCursor.findIndex(bookCur => bookCur.courseId === book.courseId)

        if (index === -1) {
          bookCursor.push({
            courseId: book.courseId,
            courseCode: book.courseCode,
            courseName: book.courseName,
          })
        }
      })
      window.localStorage.setItem('bookCursors', JSON.stringify(bookCursors))
      this.$patch({
        bookCursors: bookCursors,
      })
    },
    updateBookCursorsForStorage() {
      const bookCursorsString = window.localStorage.getItem('bookCursors')

      if (bookCursorsString) {
        this.bookCursors = JSON.parse(bookCursorsString)
      }
    },
  },
})
